'use client';

import { SignIn } from '@clerk/nextjs';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

export default function LoginPage() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        {/* Back to Home Link */}
        <div className="mb-6">
          <Link
            href="/"
            className="inline-flex items-center gap-2 text-text-secondary hover:text-text-primary transition-colors duration-200"
          >
            <Icon name="ArrowLeftIcon" size={20} />
            <span className="font-medium">Back to Home</span>
          </Link>
        </div>

        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-text-primary mb-2">Welcome Back</h1>
          <p className="text-text-secondary">Sign in to Offer XRay</p>
        </div>
        <SignIn 
          appearance={{
            elements: {
              rootBox: 'w-full',
              card: 'bg-surface shadow-lg rounded-lg border border-border',
              headerTitle: 'text-text-primary',
              headerSubtitle: 'text-text-secondary',
              socialButtonsBlockButton: 'bg-muted border border-border text-text-primary hover:bg-muted/80',
              formFieldLabel: 'text-text-primary',
              formFieldInput: 'bg-background border border-border text-text-primary focus:ring-2 focus:ring-primary',
              formButtonPrimary: 'bg-primary hover:bg-primary/90 text-primary-foreground',
              footerActionLink: 'text-primary hover:text-primary/80',
              identityPreviewText: 'text-text-primary',
              identityPreviewEditButton: 'text-primary',
            },
          }}
          routing="path"
          path="/login"
          signUpUrl="/signup"
          afterSignInUrl="/document-upload"
        />
      </div>
    </div>
  );
}

